module.exports = new __parcel__URL__("gba.8b18edb4.png").toString();